import * as React from 'react';
import { Component } from 'react';

import './TaxiHomeView.scss';
import { Promocode } from '../../../models/Promocodes/promocodes';
import i18next from 'i18next';
import { copyToClipboard } from '../../../lib/utils';
import { toast, ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

interface TaxiHomeViewProps {
    promocodes: Promocode[] | null;
    error: string;
    getPromocodes: () => any;
    lang: string;
    device: string;
}

export default class TaxiHomeView extends Component<TaxiHomeViewProps> {

    notify = () => toast.success(i18next.t('code_copied_successfully'));

    render() {
        const { promocodes, error, device, lang, getPromocodes } = this.props;
        return (
            <div>
                <ToastContainer
                    position={'top-center'}
                    autoClose={5000}
                    hideProgressBar={true}
                    closeOnClick={true}
                    draggable={true}
                    draggablePercent={50}
                />
                <div className='taxi-container'>
                    {promocodes
                        ? promocodes.map((promocode, i) =>
                            <div
                                key={i}
                                className='flex'
                                onClick={() => {
                                    copyToClipboard(promocode.code);
                                    this.notify();
                                }}
                            >
                                <img src={require('../../../assets/promocode-background.png')} />
                                <div key={i} className='taxi-container__promocode'>{promocode.code}</div>
                                <div className='taxi-container__promocode copy-button'>{i18next.t('copy')}</div>
                            </div>)
                        : <div>
                            <img src={require('../../../assets/taxi-promocode.png')} />
                        </div>}
                    <div className='taxi-container__disclaimer'>
                        {i18next.t('taxi_disclaimer')}
                    </div>
                    <div className='taxi-container__title'>
                        {i18next.t('taxi')}
                    </div>
                    {i18next.t('taxi_promocode_description')}
                    <div className='taxi-container__title'>
                        {i18next.t('how_to_use_promocode')}
                    </div>
                    <div>
                        1. <a href={device === 'iphone' ? `https://apps.apple.com/ru/app/bolt-fast-affordable-rides/id675033630?l=${lang}` : `https://play.google.com/store/apps/details?id=ee.mtakso.client&hl=${lang}&gl=US`}>{i18next.t('download')}</a> {i18next.t('bolt_download1')}
                    </div>
                    <div>
                        2. {i18next.t('bolt_download2')}
                        <img src={require('../../../assets/bolt-download1.png')} />
                    </div>
                    <div>
                        3. {i18next.t('bolt_download3')}
                        <img src={require('../../../assets/bolt-download2.png')} />
                    </div>
                    <div>
                        4. {i18next.t('bolt_download4')}
                        <img src={require('../../../assets/bolt-download3.png')} />
                    </div>
                </div>
                {!promocodes && !error && <div className='taxi-container__button'>
                <button onClick={() => getPromocodes()}>
                    {i18next.t('get_promocode')}
                </button>
            </div>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Promocodes/Taxi/TaxiHomeView.tsx